import { Box, Card, Grid, Icon, styled } from '@mui/material';
import { Button, Input, Modal, Popconfirm, Spin, Tag, message } from "antd";
import React, { useMemo, useState } from "react";
import { H4, Small } from '../../../components/Typography';

import { getStatus } from '../../../utils/misc';

import { useQueryClient } from 'react-query';
import axios from '../../../../axios';
import { route } from '../../../requests/routes';
import { orderTotalCalculate } from '../../../utils/misc';
import { useChangePaymentMethod, useGetOrderStatusByOrderId, useResetOrderStatus, useUpdateOrder } from "./../../../requests/order.js";

import { getBaseUrl } from '../../../../config/base-url.js';
import useOrders from "../../../hooks/orders/useOrders";
import { useOrder } from '../orderStore';

const StyledCard = styled(Card)(({ theme }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '24px !important',
    background: theme.palette.background.paper,
    [theme.breakpoints.down('sm')]: { padding: '16px !important' },
}));

const ContentBox = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& small': { color: theme.palette.text.secondary },
    '& .icon': { opacity: 0.6, fontSize: '44px', color: theme.palette.primary.main },
}));

const Heading = styled('h6')(({ theme }) => ({
    margin: 0,
    marginTop: '2px',
    fontSize: '13px',
    fontWeight: '500',
    color: theme.palette.primary.main,
}));

const OrderSummeryCard = ({ order, loadData }) => {
    
    const [status, setStatus] = useState(null);
    const [deliveryType, setDeliveryType] = useState('Standard');

    useMemo(() => {
        if (order) {
            let dType = order?.vendor?.mart?.delivery_type;
            if (dType) {
                setDeliveryType(dType)
            }
        }
    }, [order])

    // get mart by seller_id

    const id = order?.id;
    // fetch Current Status
    const { data: statusResponse } = useGetOrderStatusByOrderId(id);
    useMemo(() => {
        if (statusResponse) {
            setStatus(statusResponse?.event)
        }
    }, [statusResponse]);

    const orderData = orderTotalCalculate(order, order?.products);

    // status

    const [isLoading, setIsLoading] = useState(false);
    const { dispatch, state } = useOrder();
    const [cancelReason, setCancelReason] = useState('');
    const [shippingOpen, setShippingOpen] = useState(false);
    const [shippingValue, setShippingValue] = useState(0);
    const [platformFeeOpen, setPlatformFeeOpen] = useState(false);
    const [platformFeeValue, setPlatformFeeValue] = useState(0);
    const { mutate: updateOrder, isLoading: updatingShipping } = useUpdateOrder();
    const { mutate: updatePlatformFee, isLoading: updatingPlatformFee } = useUpdateOrder();
    const queryClient = useQueryClient();
    let { getOrderDetail } = useOrders();

    function handleStatus(action) {
        setIsLoading(true)
        axios.post(route.ORDER_STATUS_CHANGE, {
            event: action,
            order_id: id,
            cancel_reason: cancelReason
        }).then(() => {
            message.success('Order Status Changed');
            queryClient.invalidateQueries([route.ORDER_STATUS_BY_ORDER_ID, id]);
            queryClient.invalidateQueries([route.ORDER_STATUS_LIST_BY_ID, id]);
            setIsLoading(false);
            getOrderDetail(id);
            dispatch({ type: "CANCEL_ORDER", payload: null });
        }).catch(err => {
            message.error(err?.response?.data?.message);
            setIsLoading(false)
        });
    };


    function printInvoice(){
        window.open(`${getBaseUrl()}/api/orders/single-invoice-print/${order.id}`);
    }

    const { mutate } = useResetOrderStatus();
    const { mutate: changePaymentMethod } = useChangePaymentMethod();


    function plateFormFee(){
        let plateform_fee = 0;
        if (order['plateform_fee'] &&!isNaN(order['plateform_fee'])) {
            plateform_fee = order['plateform_fee'];
        }
        return plateform_fee;
    }


    function getRemainingAmount(order) {
        // if order['plateform_fee'] and not isNaN then add plateform_fee
        let plateform_fee = plateFormFee();
        return orderData.total + plateform_fee;
    }




    function invoiceTotal(){
        let plateform_fee = plateFormFee();
        console.log('Plateform Fee: ', plateform_fee);

        var total = (orderData.sub_total + orderData.delivery_charges) - orderData.coupon_price;
        total = total + plateform_fee;
        return total;
    }


    return (
        <>
            <StyledCard elevation={6}>
                <H4>Order Summary</H4>
                <Grid container spacing={1}>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <ContentBox>
                            <Box>
                                <Heading>
                                    Sub Total
                                </Heading>
                            </Box>
                            <Box>
                                <H4>
                                    ৳{orderData.sub_total}
                                </H4>
                            </Box>
                        </ContentBox>
                    </Grid>

                    {
                        order.coupon_price > 0 ? <Grid item lg={12} md={12} sm={12} xs={12}>
                            <ContentBox>
                                <Box>
                                    <Heading>
                                        Discount
                                    </Heading>
                                </Box>
                                <Box>
                                    <H4>
                                        ৳{orderData.coupon_price}
                                    </H4>
                                </Box>
                            </ContentBox>
                        </Grid> : null
                    }

                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <ContentBox>
                            <Box>
                                <Heading>
                                    Shipping
                                    <Button type="link" size="small" icon={<Icon className="icon" style={{ fontSize: 16, opacity: 0.6 }}>edit</Icon>} onClick={() => { setShippingValue(orderData.delivery_charges); setShippingOpen(true); }} />
                                </Heading>
                            </Box>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <H4>
                                    {orderData.delivery_charges > 0 ? `৳${orderData.delivery_charges}` : 'Free Delivery'}
                                </H4>
                            </Box>
                        </ContentBox>
                    </Grid>

                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <ContentBox>
                            <Box>
                                <Heading>
                                    Plateform Fee
                                    <Button type="link" size="small" icon={<Icon className="icon" style={{ fontSize: 16, opacity: 0.6 }}>edit</Icon>} onClick={() => { setPlatformFeeValue(plateFormFee()); setPlatformFeeOpen(true); }} />
                                </Heading>
                            </Box>
                            <Box>
                                <H4>
                                    ৳{plateFormFee()}
                                </H4>
                            </Box>
                        </ContentBox>
                    </Grid>

                    <Grid item lg={12} md={12} sm={12} xs={12}>
                    <hr />
                        <ContentBox>
                            <Box>
                                <Heading>
                                    Invoice Total
                                </Heading>
                            </Box>
                            <Box>
                                <H4>
                                    
                                    {invoiceTotal()}
                                </H4>
                            </Box>
                        </ContentBox>
                    </Grid>

                    {
                        order.paid_amount > 0 ?
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                               
                                <ContentBox>
                                    <Box>
                                        <Heading>
                                            Paid
                                        </Heading>
                                    </Box>
                                    <Box>
                                        <H4>
                                            - ৳{order.paid_amount}
                                        </H4>
                                    </Box>
                                </ContentBox>
                            </Grid> : null
                    }

                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <ContentBox>
                            <Box>
                                <H4>
                                    Remaining amount
                                </H4>
                            </Box>
                            <Box>
                                <H4>
                                    ৳{getRemainingAmount(order)}
                                </H4>
                            </Box>
                        </ContentBox>
                    </Grid>
                </Grid>
            </StyledCard>

            <Modal
                title="Edit Shipping Charge"
                open={shippingOpen}
                onCancel={() => setShippingOpen(false)}
                okText="Save"
                confirmLoading={updatingShipping}
                onOk={() => {
                    updateOrder({ id: order.id, delivery_charges: Number(shippingValue) }, {
                        onSuccess: () => {
                            message.success('Shipping charge updated');
                            setShippingOpen(false);
                            loadData();
                        },
                        onError: (err) => {
                            message.error(err?.message || 'Update failed');
                        }
                    })
                }}
            >
                <Input
                    type="number"
                    addonBefore="Delivery Charge"
                    value={shippingValue}
                    onChange={e => setShippingValue(e.target.value)}
                />
            </Modal>

            <Modal
                title="Edit Platform Fee"
                open={platformFeeOpen}
                onCancel={() => setPlatformFeeOpen(false)}
                okText="Save"
                confirmLoading={updatingPlatformFee}
                onOk={() => {
                    updatePlatformFee({ id: order.id, plateform_fee: Number(platformFeeValue) }, {
                        onSuccess: () => {
                            message.success('Platform fee updated');
                            setPlatformFeeOpen(false);
                            loadData();
                        },
                        onError: (err) => {
                            message.error(err?.message || 'Update failed');
                        }
                    })
                }}
            >
                <Input
                    type="number"
                    addonBefore="Platform Fee"
                    value={platformFeeValue}
                    onChange={e => setPlatformFeeValue(e.target.value)}
                />
            </Modal>

            <br />
            <StyledCard elevation={6}>
                <ContentBox>
                    <Icon className="icon">payment</Icon>
                    <Box ml="12px">
                        <div>
                            <Small>Payment Method</Small>
                            <Heading>
                                {
                                    String(order.payment_method.toUpperCase()).toLowerCase() === "none" ?
                                        "Waiting for payment" :
                                        order.payment_method.toUpperCase()
                                }
                            </Heading>
                        </div>

                        {String(order.payment_method.toUpperCase()).toLowerCase() === "none" && <div>
                            <Button onClick={e => {
                                changePaymentMethod({ order_id: order.id, payment_method:'cash' }, {
                                    onSuccess:() => {
                                        message.success('Payment method changed successfull');
                                        loadData();
                                    },
                                    onError:err => {
                                        message.error(err?.message);
                                    }
                                })
                            }}>Make it Cash</Button>
                        </div>}
                    </Box>
                </ContentBox>
            </StyledCard>

            <br />
            <StyledCard elevation={6}>
                <ContentBox>
                    <Icon className="icon">diamond</Icon>
                    <Box ml="12px">
                        <Small>Order Status</Small>
                        <Heading>
                            {statusResponse && getStatus(statusResponse?.event)}
                        </Heading>

                        {order?.cancel_reason &&
                            <div style={{
                                padding: "10px 0px",
                            }}>
                                <span style={{ fontSize: 12 }}>{order?.cancel_reason}</span>
                            </div>
                        }

                        {order?.cancel_by &&
                            <span style={{ fontSize: 12 }}>
                                <Tag>cancel By:</Tag>  {order?.cancel_by}
                            </span>
                        }
                    </Box>
                </ContentBox>
            </StyledCard>

            {/* <br /> */}
            {/* <StyledCard elevation={6}>
                <ContentBox>
                    <Box ml="12px">
                        <Button  onClick={printInvoice}>Print Invoice</Button>
                    </Box>
                </ContentBox>
            </StyledCard> */}
        
            
            <br />
            <StyledCard elevation={10}>
                <ContentBox style={{ width:"100%", display:"flex", justifyContent:"space-between", alignItems:"center" }}>

                    <H4> Manage Order Status </H4>

                        <div style={{ 

                         }}>
                            {
                            // status === "order_cancel" || status === "order_cancel_with_refund" || status ==="order_delivered" && 
                                <Popconfirm
                                title="Are you sure to reset ? 
                                It will reset Vendor and rider Transection for this order"
                                onConfirm={e => {
                                    mutate({
                                        order_id: order?.id
                                    }, {
                                        onSuccess:() => {
                                            if(typeof window !== 'undefined'){
                                                window.location.reload();
                                            }
                                        },
                                        onError:err => {
                                            message(err?.message)
                                        },
                                       
                                    })
                                }}
                                > 
                                    <Button 
                                        danger 
                                        >
                                        Reset Order status
                                    </Button>
                                </Popconfirm>
                            }
                        </div>
                </ContentBox>

                <Grid container spacing={2}>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <br />
                        {isLoading ?
                            <ContentBox>
                                <Spin />
                            </ContentBox> :
                            <ContentBox>
                                <Box>
                                    {status === "order_placed" && StatusHandle({ setIsLoading, title: 'Accept', action: 'order_confirmed', id })}
                                    {status === "order_confirmed"
                                        && deliveryType === 'Express'
                                        && StatusHandle({ setIsLoading, title: 'Order Preparing', action: 'order_preparing', id })}

                                    {status === "order_confirmed"
                                        && deliveryType === 'Standard'
                                        && StatusHandle({ setIsLoading, title: 'Ready For Shipment', action: 'ready_for_shipment', id })}

                                    {status === "order_preparing"
                                        && deliveryType === 'Express'
                                        && StatusHandle({ setIsLoading, title: 'Rider Pickup', action: 'rider_pickup', id })}

                                    {status === "ready_for_shipment"
                                        && deliveryType === 'Standard'
                                        && StatusHandle({ setIsLoading, title: 'Ship to courier', action: 'ship_to_courier', id })}

                                    {status === "rider_pickup" && StatusHandle({ setIsLoading, title: 'On the way', action: 'order_on_the_way', id })}
                                    {status === "ship_to_courier" && StatusHandle({ setIsLoading, title: 'On the way', action: 'order_on_the_way', id })}

                                    {status === "order_on_the_way" && StatusHandle({ setIsLoading, title: 'Order Delivered', action: 'order_delivered', id })}

                                    {status === "order_delivered" && <Tag color='green'>Order Delivered Successfully</Tag>}
                                    {status === "order_cancel" && <Tag color='red'>Order Cenceled</Tag>}
                                </Box>

                                <Box>
                                    {status === "order_placed" && StatusHandle({ setIsLoading, title: 'Reject', action: 'order_cancel', id })}
                                    {status === "order_confirmed" && StatusHandle({ setIsLoading, title: 'Reject', action: 'order_cancel', id })}
                                    {status === "order_preparing" && StatusHandle({ setIsLoading, title: 'Reject', action: 'order_cancel', id })}
                                    {status === "rider_pickup" && StatusHandle({ setIsLoading, title: 'Reject', action: 'order_cancel', id })}
                                    {status === "order_on_the_way" && StatusHandle({ setIsLoading, title: 'Reject', action: 'order_cancel', id })}
                                    {status === "ready_for_shipment" && StatusHandle({ setIsLoading, title: 'Reject', action: 'order_cancel', id })}
                                    {status === "ship_to_courier" && StatusHandle({ setIsLoading, title: 'Reject', action: 'order_cancel', id })}
                                </Box>
                            </ContentBox>
                        }

                    </Grid>

                    

                </Grid>
            </StyledCard>

            {/* Modal for reject Order */}
            <Modal
                okButtonProps={{ loading: isLoading }}
                okText="Confirm"
                centered title="Cancel Reason"
                open={state?.cancel_order_id !== null ? true : false}
                onOk={() => {
                    // submit cancel order
                    if(cancelReason ===''){
                        message.error('Kindly Provide the Cancellation Reason');
                        return;
                    };
                    handleStatus('order_cancel');
                }}
                onCancel={() => {
                    dispatch({ type: "CANCEL_ORDER", payload: null });
                }}>
                <Input.TextArea
                    placeholder='Write Reason'
                    rows={5}
                    onChange={e => {
                        setCancelReason(e.target.value);
                    }}
                />
            </Modal>
        </>
    );
};

export default OrderSummeryCard;

function StatusHandle({ title, action, id, setIsLoading }) {

    const queryClient = useQueryClient();
    let { getOrderDetail } = useOrders();

    const { dispatch } = useOrder();

    function handleStatus() {
        setIsLoading(true)
        axios.post(route.ORDER_STATUS_CHANGE, { event: action, order_id: id }).then(() => {
            message.success('Order Status Changed');
            queryClient.invalidateQueries([route.ORDER_STATUS_BY_ORDER_ID, id]);
            queryClient.invalidateQueries([route.ORDER_STATUS_LIST_BY_ID, id]);

            setIsLoading(false);
            getOrderDetail(id);
        }).catch(err => {
            message.error(err?.response?.data?.message);
            setIsLoading(false)
        })
    }

    return <>
        <Button onClick={() => {
            if (action === 'order_cancel') {
                // Open Popup
                dispatch({ type: "CANCEL_ORDER", payload: id });
                return false;
            }

            handleStatus();
        }}>{title}</Button>
    </>
}
